import { useState, useEffect } from "react";
import { getTranslation } from "../translations/getTranslations";
import { useSelector } from "react-redux";

const useMobilePWAInstall = () => {
  const language = useSelector(state => state.settings.language);
  const translation = key => getTranslation("pwa", key, language);

  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor;

    setIsAndroid(/Android/i.test(ua));
    setIsIOS(/iPhone|iPad|iPod/i.test(ua));
  }, []);

  const showInstructions = () => {
    if (isAndroid) {
      alert(translation("androidInstall"));
      return;
    }

    if (isIOS) {
      alert(translation("safariInstall"));
      return;
    }

    alert(translation("notSupported"));
  };

  return showInstructions;
};

export default useMobilePWAInstall;
